<template>
  <div>
    <SubstituteUsersDataTable />
  </div>
</template>
<script>
import SubstituteUsersDataTable from "@/v3components/Datatables/SubstituteUsersDataTable"

export default {
  name: "SubstituteUsers",
  components: { SubstituteUsersDataTable }
}
</script>
